import { useEffect, useState } from 'react';

import P from 'prop-types';
import { Api } from '../../../services/api';
import { CanhotoView } from '../../CanhotoView';

export const CanhotosComponent = ({ idCarga }) => {
  const [isViewCanhoto, setIsViewCanhoto] = useState(false);
  const [canhotos, setCanhotos] = useState(null);

  const [selected, setSelected] = useState(null);

  const findCanhotos = async () => {
    console.log('Só pra confirmar');
    try {
      const all = await Api.get(`/canhotos/${idCarga}`);
      setCanhotos(all.data);
      console.log(all.data);
    } catch {
      setCanhotos(null);
    }
  };

  const closeFunc = () => {
    setIsViewCanhoto((e) => !e);
    setSelected(null);
  };

  useEffect(() => {
    findCanhotos();

    return () => {
      setIsViewCanhoto(false);
      setSelected(null);
    };
  }, [idCarga]);

  return (
    <div>
      {selected && isViewCanhoto ? (
        <CanhotoView id={selected} close={closeFunc} />
      ) : (
        <>
          {canhotos ? (
            canhotos.map((obj) => {
              return (
                <>
                  <div key={obj.id} className="input-group mb-4">
                    <span className="form-control">NF - {obj.nf}</span>
                    {!obj.arquivo ? (
                      <div className="btn-group" role="group" aria-label="Basic mixed styles example">
                        <button type="button" className="btn btn-secondary" disabled>
                          Aguardando canhoto
                        </button>
                      </div>
                    ) : obj.idStatus == 3 ? (
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                          setIsViewCanhoto((e) => !e);
                          setSelected(obj.id);
                          console.log('Seu ID:', obj.id);
                        }}
                      >
                        Consultar
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => {
                          setIsViewCanhoto((e) => !e);
                          setSelected(obj.id);
                          console.log('Seu ID:', obj.id);
                        }}
                      >
                        Validar
                        <span className="position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle">
                          <span className="visually-hidden">New alerts</span>
                        </span>
                      </button>
                    )}
                  </div>
                </>
              );
            })
          ) : (
            <div>Não encontramos nenhum canhoto</div>
          )}
        </>
      )}
    </div>
  );
};

CanhotosComponent.propTypes = {
  idCarga: P.number,
};
